module.exports = __webpack_public_path__ + "static/media/dot-three.6bd8f741.svg";